import React from "react";
import Modal from "../../Elements/Modal/Modal";
import MainButton from "../../Elements/MainButton/MainButton";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import "./CsvImportInfoModal.css";

const COLUMNS = [
  "Name",
  "Description",
  "Duration",
  "GB",
  "Country",
  "Region",
  "Markup Rate",
  "Markup Margin",
  "Price",
  "Currency",
];

const EXAMPLE_ROWS = [
  ["Finland 1GB 2days", "Finland 1 GB 2 days", "2", "1.0", "FI", "", "0.5", "0.0", "1.1988809999999999", "USD"],
  ["Ireland 1GB 2days", "Ireland 1 GB 2 days", "2", "1.0", "IE", "", "0.5", "0.0", "1.1988809999999999", "USD"],
];

const CsvImportInfoModal = ({ isOpen, onClose, onContinue }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Import CSV"
    actions={
      <>
        <SecondButton onClick={onClose}>Cancel</SecondButton>
        <MainButton onClick={onContinue}>Choose file</MainButton>
      </>
    }
  >
    <div className="csv-info-body">
      <p className="csv-info-text">The CSV file must contain these columns, in this exact order:</p>
      <p className="csv-info-text">{COLUMNS.join(", ")}</p>

      <p className="csv-info-text">Example:</p>
      <div className="csv-info-table-wrap">
        <table className="csv-info-table">
          <thead>
            <tr>
              {COLUMNS.map((c) => (
                <th key={c}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {EXAMPLE_ROWS.map((row, i) => (
              <tr key={i}>
                {row.map((v, j) => (
                  <td key={j}>{v || "—"}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </Modal>
);

export default CsvImportInfoModal;
